import React, {useEffect, useState} from 'react';
import {useRouter} from 'next/router';
import SwiperCore, {A11y, Autoplay, Navigation, Pagination, Scrollbar} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import NewsService from '../../services/news.service';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
import 'swiper/swiper-bundle.min.css';
import styles from './ThePressSaysAboutTnh.module.css';
import {getLocaleContent} from '@helper/locale-content.js';
import Link from 'next/link';
import {changeToSlug} from '@helper/string.helper';

export default function ThePressSaysAboutTnh() {
    const {locale} = useRouter();
    const [news, setNews] = useState([]);
    const [currentSlidesPerView, setCurrentSlidesPerView] = useState(1);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (!locale) return;

        const newsService = new NewsService();
        newsService
            .getNewsList({
                locale,
                pageSize: 10,
                pageIndex: 1,
                keyword: '',
                news_category_id: 24, // ID của category "Báo chí nói về TNH"
            })
            .then(res => {
                const items = res.data || [];
                setNews(items);
            })
            .catch(error => console.error('Error fetching news:', error));
    }, [locale]);

    const swiperConfig = {
        spaceBetween: 24,
        navigation: {
            nextEl: `.${styles['nav']} .bw_hover_prev`,
            prevEl: `.${styles['nav']} .bw_hover_next`,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },
        onInit: swiper => {
            setCurrentSlidesPerView(swiper.params.slidesPerView);
            setActiveIndex(swiper.activeIndex);
        },
        onResize: swiper => {
            setCurrentSlidesPerView(swiper.params.slidesPerView);
        },
        onSlideChange: swiper => {
            setActiveIndex(swiper.activeIndex);
        },
    };

    return (
        <>
            <section className="container">
                <header>
                    <h2 className={styles['title']}>
                        <span>{getLocaleContent(locale, 'page.press-say.title1')}</span>{' '}
                        {getLocaleContent(locale, 'page.press-say.title2')}
                    </h2>
                </header>
                <div className={styles['press-carousel']}>
                    <Swiper {...swiperConfig} className={styles['thumbnail-swiper']}>
                        {news.map((item, index) => {
                            // Determine middle (active) chevron logic based on slides per view
                            let isChevronActive = false;
                            if (currentSlidesPerView === 1) {
                                // Mobile: only current slide
                                isChevronActive = index === activeIndex;
                            } else if (currentSlidesPerView === 2) {
                                // Tablet: middle card doesn't exist, activate first visible
                                isChevronActive = index === activeIndex;
                            } else if (currentSlidesPerView === 3) {
                                // Desktop: middle card (activeIndex + 1)
                                isChevronActive = index === activeIndex + 1;
                            }

                            return (
                                <SwiperSlide key={item.news_id}>
                                    <div className={styles['card']}>
                                        <img
                                            src={item.image_url || '/bw_image/news-image.png'}
                                            alt={item.news_title}
                                            className={styles['card-image']}
                                        />
                                        <div className={styles['card-content']}>
                                            <h3 className={styles['card-title']}>{item.news_title}</h3>
                                            <p className={styles['card-description']}>{item.short_description}</p>
                                        </div>
                                        <Link
                                            href={{
                                                pathname: '/[slug]',
                                                query: {slug: `${changeToSlug(item.news_title)}-d${item.news_id}`},
                                            }}>
                                            <a
                                                className={styles['card-button']}
                                                aria-label={`${
                                                    locale === 'en' ? 'Read article' : 'Đọc bài viết'
                                                }: ${item.news_title}`}
                                                style={{
                                                    cursor: 'pointer', // luôn pointer
                                                    opacity: isChevronActive ? 1 : 0.5, // vẫn giữ hiệu ứng active
                                                }}>
                                                <img
                                                    src={
                                                        isChevronActive
                                                            ? '/bw_image/chevron-right-active.svg'
                                                            : '/bw_image/chevron-right-inactive.svg'
                                                    }
                                                    alt=""
                                                    className={styles['arrow-icon']}
                                                />
                                            </a>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
                <div className={styles['nav']}>
                    <button className="navbtn bw_hover_next" aria-label="Prev"></button>
                    <button className="navbtn bw_hover_prev" aria-label="Next"></button>
                </div>
            </section>
        </>
    );
}
